import { BaseService } from './base.service';
import { Injector, Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProductService extends BaseService {
  openFilter = new EventEmitter();
  closeFilter = new EventEmitter();

  constructor(
    protected injector: Injector
  ) {
    super(injector);
    this.setBaseCollection('products');
  }
}
